<template>
    <div class="list-nav_wrapper broker">
        <div class="nav_container" ref="navContainer">
            <div class="nav">
                <div
                    v-for="(listing, index) in showNavList"
                    :key="listing.id"
                    class="nav_item"
                    :class="{
                        //  When initializing a item highlight
                        //  After the currently clicked highlight
                        active:
                            (!currentListingStatus && index === 0) ||
                            currentListingStatus === listing.id
                    }"
                    @click="switchNav(listing)"
                >
                    {{ listing.name }}
                </div>
                <div class="drop_container">
                    <drop-down-nav
                        v-if="showDropDown"
                        :nav-list="hideNavList"
                        customLabel="more"
                    />
                </div>
            </div>
            <div class="slave_nav" ref="slaveNav">
                <div
                    v-for="listing in listingStatus"
                    :key="listing.id"
                    class="nav_item"
                >
                    {{ listing.name }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import common from '../../../_mixins/nav/common';
import PcNav from '../../../_mixins/nav/pc';
import DropDownNav from '../../../standard/components/nav/drop-down-nav';
export default {
    name: 'listing-nav',
    mixins: [common, PcNav],
    components: { 'drop-down-nav': DropDownNav }
};
</script>

<style lang="scss">
.list-nav_wrapper.broker {
    box-sizing: border-box;
    height: 55px;
    .nav_container {
        width: 100%;
        position: relative;
        border-bottom: 1px solid #dadada;
    }
    .nav {
        width: 100%;
        display: flex;
        background: #fff;
        justify-content: flex-start;
        cursor: pointer;
        &.showDropDown {
            justify-content: space-between;
            .nav_item {
                flex-shrink: 1;
                flex-grow: 1;
                margin-right: 0;
            }
        }
        .nav_item {
            position: relative;
            margin-right: 40px;
            white-space: nowrap;
            line-height: 54px;
            font-size: 14px;
            font-family: var(--font-medium);
            color: #505050;
            &.active {
                border-bottom: 2px solid var(--color-theme);
                color: var(--color-theme);
                font-family: var(--font-bold);
            }
        }
    }
    .drop_container {
        flex-shrink: 1;
        flex-grow: 1;
        /* height: 100%; */
        display: flex;
        align-items: center;
        padding-bottom: 5px;
    }
    .slave_nav {
        display: flex;
        position: absolute;
        left: 0;
        top: 0;
        z-index: -1;
        justify-content: flex-start;
        flex-wrap: nowrap;
        .nav_item {
            margin-right: 35px;
            padding: 0 8px;
            white-space: nowrap;
            line-height: 54px;
            font-size: var(--label-font-size);
        }
    }
    .nav {
        .click-show-list {
            font-size: 15px;
            white-space: nowrap;
            color: var(--color-text);
        }
    }
}
</style>
